import React, { useState } from "react";
import Header from "./Components/Common/Header";
import Home from "./Components/Home";
import Footer from "./Components/Common/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import ScrollToTop from "./Components/Common/ScrollToTop";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import VenuePage from "./Components/VenuePage/VenuePage";
import RegistrationPage from "./Components/Registration/RegistrationPage";
import Accomodation from "./Components/Information/Accomodation";
import Tourism from "./Components/Information/Tourism";
import PreConferenceWorkshop from "./Components/Program/PreConferenceWorkshop";
import ConferenceHighlights from "./Components/Program/ConferenceHighlights";
import AwardsAndHonors from "./Components/Abstract/AwardsAndHonors";
import AbstractGuidelines from "./Components/Abstract/AbstractGuidelines";
import Speakers from "./Components/Program/Speakers";
import OrganizingCommittee from "./Components/Ampicon2025/OrganizingCommittee";
import ScienceCommittee from "./Components/Ampicon2025/ScienceCommittee";
import RegionalAdvisoryCommittee from "./Components/Ampicon2025/RegionalAdvisoryCommittee";
import TNPYAdvisoryCommittee from "./Components/Ampicon2025/TNPYAdvisoryCommittee";
import AMPITNPYExecutiveCommittee from "./Components/Ampicon2025/AMPITNPYExecutiveCommittee";
import LoginPage from "./Components/Registration/LoginPage";
import MainContact from "./Components/Contacts/MainContacts";
import PreFooter from "./Components/Common/PreFooter";
import LoginFloat from "./Components/Common/LoginFloat/LoginFloat";
import Privacy from "./PrivacyTerms/Privacy";
import Terms from "./PrivacyTerms/Terms";
import PaymentPage from "./Components/Registration/PaymentPage";
import UserDetailsComponent from "./Components/Registration/UserDetailsComponent";
import AbstractSubmission from "./Components/Abstract/AbstractSubmission";
import Sponcers from "./Components/Information/Sponcers";
import TypesOfCancres from "./Components/Information/TypesOfCancres";
import CancerDetail from "./Components/Information/CancerDetail";
import forgetPassword from "./Components/Registration/ForgetPassword";
import ScienceCommitteeMembers from "./Components/Ampicon2025/ScienceCommitteeMembers";
import ScientificProgram from "./Components/Program/ScientificProgram";
import ForgetPassword from "./Components/Registration/ForgetPassword";
import InternalServerError from "./Components/InternalServerError";
import ComingSoon from "./Components/Common/ComingSoon";
import SEO from "./AASeo/Seo";

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <SEO
        title="AMPICON 2025 - Conference on the Future of Medical Physics in Oncology"
        description="Join us in Chennai for AMPICON 2025, the premier conference shaping the future of Medical Physics in Oncology. Explore cutting-edge research, innovative technologies, and collaborative opportunities with leading experts in the field."
        keywords="AMPICON 2025, Medical Physics, Oncology, Conference, Chennai, Cancer Research, Radiation Therapy, Medical Imaging, Healthcare Technology"
        url="https://ampicon2025.com"
      />
      <Router>
        <Header
          mobileMenuOpen={mobileMenuOpen}
          setMobileMenuOpen={setMobileMenuOpen}
        />

        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />

          {/* AMPICON 2025 */}
          <Route
            path="/organizing-committee"
            element={<OrganizingCommittee />}
          />
          <Route path="/science-committee" element={<ScienceCommittee />} />
          <Route
            path="/science-committee-members"
            element={<ScienceCommitteeMembers />}
          />
          <Route
            path="/regional-advisory-committe"
            element={<RegionalAdvisoryCommittee />}
          />
          <Route
            path="/TNPY-advisory-committee"
            element={<TNPYAdvisoryCommittee />}
          />
          <Route
            path="/AMPI-TNPY-executive-committee"
            element={<AMPITNPYExecutiveCommittee />}
          />

          {/* Program */}
          <Route
            path="/preconference-workshop"
            element={<PreConferenceWorkshop />}
          />
          <Route
            path="/conference-highlights"
            element={<ConferenceHighlights />}
          />
          <Route path="/invited-speakers" element={<Speakers />} />
          <Route path="/scientific-program" element={<ScientificProgram />} />

          {/* Registration */}
          <Route path="/registration" element={<RegistrationPage />} />
          <Route path="/login-page" element={<LoginPage />} />
          <Route path="/userProfile" element={<UserDetailsComponent />} />
          <Route path="/paymentPage" element={<PaymentPage />} />

          {/* Abstract */}
          <Route path="/abstract" element={<AbstractGuidelines />} />
          <Route path="/awards-and-honors" element={<AwardsAndHonors />} />
          <Route path="/abstract-submission" element={<AbstractSubmission />} />

          {/* Information */}
          <Route path="/venue" element={<VenuePage />} />
          <Route path="/types-of-cancers" element={<TypesOfCancres />} />
          <Route
            path="/cancerdetail/:cancerTypeId"
            element={<CancerDetail />}
          />
          <Route path="/sponsors" element={<Sponcers />} />
          <Route path="/accommodation" element={<Accomodation />} />
          <Route path="/chennai-tourism" element={<Tourism />} />

          {/* Contact */}
          <Route path="/contacts" element={<MainContact />} />
          <Route path="/privacypolicy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/forgetPassword" element={<ForgetPassword />} />
          <Route
            path="/internal-server-error"
            element={<InternalServerError />}
          />
        </Routes>

        <PreFooter />

        <Footer />
      </Router>
    </>
  );
}

export default App;
